import type { Provider, Type } from '@angular/core';
import { InjectionToken } from '@angular/core';

import type { ColumnFactory, DataTableRow } from '@core/user-interface-legacy';
import type { DataSource, ViewRecord } from '@core/views-types';

import type { DataTransform } from './layout-tokens';
import type { LayoutListHeaderComponent } from './list-tokens';

export interface TableConfig<
  T extends DataTableRow,
  Fields extends string,
  U extends ViewRecord = T,
> {
  tableGroupHeader: Type<LayoutListHeaderComponent<ViewRecord>>;
  columns: Array<ColumnFactory<U>>;
  columnFieldMap: Record<string, Fields>;
  firstColumnSticky?: boolean;
  recordsTransform?: new () => DataTransform<T, U>;
  dynamicFieldColumn?: (id: string, label: string) => ColumnFactory<U>;
}

export type TableConfigMap = {
  [k in DataSource['id']]?: TableConfig<DataTableRow, string>;
};

export const TABLE_CONFIGS = new InjectionToken<TableConfigMap>('TABLE_CONFIGS');

export const provideTableLayout = (tableConfigs: TableConfigMap): Provider[] => [
  {
    provide: TABLE_CONFIGS,
    useValue: tableConfigs,
  },
];
